<template>
  <div class="modal-content">
    <div class="modal-header justify-content-between align-items-center bg-light px-2 py-1">
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>
      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <!-- <li class="list-inline-item mx-0 mx-lg-2">
          <div class="dropdown">
            <a
              class="btn btn-light text-secondary d-flex flex-column"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="material-icons">toggle_off</i>
              <small>设置</small>
            </a>
            <form class="dropdown-menu dropdown-menu-right p-4 shadow-lg w-200">
              <div class="pb-3">
                <p class="mb-2">更改文字大小</p>
                <div class="btn-group btn-group-toggle btn-group-font" data-toggle="buttons">
                  <label
                    class="btn btn-light text-muted btn-group-font-sm"
                    :class="{active: fontSize=== 1}"
                    @click="setFontSize(1)"
                  >
                    <input
                      type="radio"
                      name="options"
                      id="option1"
                      autocomplete="off"
                      :value="1"
                      v-model="fontSize"
                    /> 小
                  </label>
                  <label
                    class="btn btn-light text-muted btn-group-font-default"
                    :class="{active: fontSize=== 2}"
                    @click="setFontSize(2)"
                  >
                    <input
                      type="radio"
                      name="options"
                      :value="2"
                      v-model="fontSize"
                      id="option2"
                      autocomplete="off"
                    /> 中
                  </label>
                  <label
                    class="btn btn-light text-muted btn-group-font-lg"
                    :class="{active: fontSize=== 3}"
                    @click="setFontSize(3)"
                  >
                    <input
                      :value="3"
                      v-model="fontSize"
                      type="radio"
                      name="options"
                      id="option3"
                      autocomplete="off"
                    /> 大
                  </label>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <div class="pt-2">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="hasMuted"
                    id="customSwitch2"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch2"
                  >{{hasMuted?"关闭": "打开"}}答题音效</label>
                </div>
              </div>
            </form>
          </div>
        </li>-->
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
        <li class="list-inline-item mx-0 mx-lg-2" v-if="exerciseType == 8">
          <button
            @click="openPzFilter"
            type="button"
            class="btn btn-light text-secondary collapsed d-flex flex-column"
          >
            <i class="pz-icon icon-filter"></i>
            <small class="d-none d-md-inline-block">筛选</small>
          </button>
        </li>
      </ul>
    </div>
    <div class="modal-body p-0">
      <div
        class="h-100 d-flex flex-column justify-content-center align-items-center overflow-hidden"
      >
        <div class="mb-5">
          <img
            src="https://resources.pzacademy.com/image/class-ui/NoData.svg"
            width="200"
            style="opacity: 0.5"
          />
        </div>
        <div class="w-50 mb-5">
          <h5 class="text-center text-muted">{{ message }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  name: 'NoData',

  props: {
    isFullscreen: Boolean,
    onResizeModal: Function,
    title: String,

    onClose: {
      type: Function,
      default: () => {},
    },
    exerciseType: {
      type: Number,
      default: () => '',
    },

    content: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    message: function () {
      let str = '';
      switch (this.exerciseType) {
        case 1:
          str = '暂时无法为您提供智能练习，请您再多学一些知识点';
          break;
        case 2:
          str = '暂无收藏，请添加练习题';
          break;
        case 3:
          str = '暂无错题，继续保持～';
          break;
        case 11:
          str = '没有章节练习数据';
          break;
        case 12:
          str = '没有单元测试数据';
          break;
        case 13:
          str = '没有模拟考试数据';
          break;
        case 8:
          str = '筛选条件下没有练习题';
          break;
        default:
          str = '该部分没有练习题';
      }
      return str;
    },
  },

  methods: {
    openPzFilter() {
      $('#pzFilter').modal({ backdrop: false, show: true });
    },
  },
};
</script>
